require('./baseState.js');

PegasusTemplate.IdlingState = PegasusTemplate.BaseState.extend({
  setup: function(){
    var blockOps = PegasusTemplate.lookupController('blockOperations');

    blockOps.set('content', null);
    PegasusTemplate.lookupController('application').incrementProperty('shouldSizeScrollbar');
    PegasusTemplate.lookupController('historyOperations').set('shouldShow', true);
    PegasusTemplate.lookupController('application').send('enteredIdleState');
  },
  hover: function(manager, context){
    manager.transitionTo('hovering', context);
  },
  edit: function(manager, context){
    manager.transitionTo('editing', context);
  },
  gotoValidating: function(manager){
    manager.transitionTo('validating.confirming');
  },
  gotoTesting: function(manager){
    manager.transitionTo('validating.testing');
  },
  changePalette: function(manager, view){
    manager.transitionTo('editing.palette', view);
  }
});
